// Iter XX.56 — LandingV2 experiment assignment.
// Deterministic 50/50 by user_id (when linked) or browser_id, with a
// master kill switch via REACT_APP_FEATURE_LANDING_V2. Founder override
// via localStorage.gully_landing_v2 ∈ { "1" | "0" }.

function _hash(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h) ^ str.charCodeAt(i);
  return Math.abs(h);
}

export function getBrowserId() {
  try {
    let b = localStorage.getItem("gully_browser_id");
    if (!b) {
      b = "b_" + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      localStorage.setItem("gully_browser_id", b);
    }
    return b;
  } catch { return "b_anon"; }
}

export function getLandingVariant({ userId } = {}) {
  // Master kill switch: OFF → always control (existing Landing).
  const master = (process.env.REACT_APP_FEATURE_LANDING_V2 || "on").toLowerCase();
  if (master === "off") return { variant: "control", reason: "flag_off" };

  // Founder override.
  try {
    const o = localStorage.getItem("gully_landing_v2");
    if (o === "1") return { variant: "v2", reason: "override" };
    if (o === "0") return { variant: "control", reason: "override" };
  } catch { /* ignore */ }

  const key = userId || getBrowserId();
  const bucket = _hash(String(key)) % 100;
  return { variant: bucket < 50 ? "v2" : "control", reason: "assigned" };
}

export function persistVariant(variant) {
  try { localStorage.setItem("gully_landing_variant", variant); } catch { /* ignore */ }
}
